<template>
  <span :class="`bundle bundle-${color}`">
    {{ $t(`db.database.status.${value}`) }}
  </span>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: ''
      }
    },

    computed: {
      color: function() {
        /* eslint-disable no-unreachable, vue/script-indent */
        switch (this.value) {
          case 'ready': {
            return 'green';
          }
          case 'fresh': {
            return 'blue';
          }
          case 'error': {
            return 'error';
          }
          case 'removed': {
            return 'gray';
          }
          case 'processing': {
            return 'fresh';
          }
          case 'sorting': {
            return 'orange';
          }
          default: {
            return 'default';
          }
        }
        /* eslint-enable */
      }
    }
  };
</script>
